import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { db, auth } from "../../firebase/firebase";
import "./NavBar.css";

const siteType = process.env.REACT_APP_SITE_TYPE;

const NavBar = () => {
  const [categories, setCategories] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);

  // Load categories
  useEffect(() => {
    const fetchCats = async () => {
      try {
        const q = query(
          collection(db, "categories"),
          orderBy("order", "asc")
        );

        const snap = await getDocs(q);

        const list = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCategories(list);
      } catch (err) {
        console.error("Error loading categories:", err);
      }
    };

    fetchCats();
  }, []);

  // Detect auth state
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
    });
    return () => unsub();
  }, []);

  // Close mobile menu when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      const menu = document.querySelector(".mobile-menu");
      const button = document.querySelector(".hamburger");

      // If menu is open AND click is outside both menu and button → close it
      if (
        menuOpen &&
        menu &&
        !menu.contains(e.target) &&
        button &&
        !button.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [menuOpen]);


  // MAIN site uses /shop/...   SHOP site uses /...
  const base = siteType === "SHOP" ? "/shop" : "/shop";
  const home = siteType === "SHOP" ? "/" : "/home";


  return (
    <div className="nav-wrapper">

      {/* DESKTOP NAV */}
      <div className="shop-nav desktop-nav">
        <NavLink to={home} className="shop-nav-item">Home</NavLink>
        <NavLink to="/blog" className="shop-nav-item">Blog</NavLink>

        {categories.map((cat) => {
          const path =
            cat.slug === "blog"
              ? `${base}/`
              : `${base}/${cat.slug}`;

          return (
            <NavLink key={cat.id} to={path} className="shop-nav-item">
              {cat.name}
            </NavLink>
          );
        })}

        {/* Always show About */}
        <NavLink to="/shop/about" className="shop-nav-item">About</NavLink>

        {/* Show Admin only when logged in */}
        {user && (
          <NavLink to="/admin/dashboard" className="shop-nav-item">
            Admin
          </NavLink>
        )}
      </div>

      {/* MOBILE NAV */}
      <div className="mobile-nav">
        <button
          className="hamburger"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          ☰
        </button>

        <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
          <NavLink
            to={home}
            className="mobile-menu-item"
            onClick={() => setMenuOpen(false)}
          >
            Home
          </NavLink>

          <NavLink
            to="/blog"
            className="mobile-menu-item"
            onClick={() => setMenuOpen(false)}
          >
            Blog
          </NavLink>

          {categories.map((cat) => {
            const path =
              cat.slug === "blog"
                ? `${base}/`
                : `${base}/${cat.slug}`;

            return (
              <NavLink
                key={cat.id}
                to={path}
                className="mobile-menu-item"
                onClick={() => setMenuOpen(false)}
              >
                {cat.name}
              </NavLink>
            );
          })}

          {/* Always show About */}
          <NavLink
            to="/shop/about"
            className="mobile-menu-item"
            onClick={() => setMenuOpen(false)}
          >
            About
          </NavLink>

          {/* Show Admin only when logged in */}
          {user && (
            <NavLink
              to="/admin/dashboard"
              className="mobile-menu-item"
              onClick={() => setMenuOpen(false)}
            >
              Admin
            </NavLink>
          )}
        </div>
      </div>

    </div>
  );
};

export default NavBar;
